<div class="modal fade" id="menuModal">
  <aside id="sidenav" class="anim-active fixed">
    <div class="container-fluid">
      <section id="sidenav-profile" class="row flex-row middle">
        <div class="col-md-2 col-sm-2 col-xs-2 text-center">
          <button data-action="closeSidenav" class="custom-btn btn-close-nav" #closeBtn data-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-3 avatar-inside">
          <div class="avatar avatar-md">
            <img src="{{userDetailsObj.image_90}}" alt="" title="" *ngIf="userDetailsObj.image_90 != null">
            <img src="/assets/images/default_avatar.png" alt="user-avatar" title="" *ngIf="userDetailsObj.image_90 == null">
          </div>
        </div>
        <div class="col-md-7 name-inside">
          <div class="profile-name">{{userDetailsObj.first_name}} {{userDetailsObj.last_name}}</div>
          <a href="/#/settings/profile" class="link link-default">View my Profile</a>
        </div>
      </section>

      <nav id="sidenav-navigation" class="row">
        <perfect-scrollbar style="width: 100%;" [ngStyle]="{'height': innerHeight+'px'}" class="scroll-container desktop-show">
          <ul class="nav col-md-12">
            <li class="nav-item row" [ngClass]="{'active': routerUrl == '/home'}">
              <div class="col-md-2 col-sm-2 col-xs-2 text-center">
                <i class="icon icon-wb stroke O8"></i>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5 text-left">
                <a href="/#/home" title="Dashboard" [ngClass]="{'active': routerUrl == '/home'}">Dashboard</a>
              </div>
            </li>
            <li class="nav-item row" [ngClass]="{'active': routerUrl == '/single-meditation'}">
              <div class="col-md-2 col-sm-2 col-xs-2 text-center">
                <i class="icon icon-wb stroke F19"></i>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5 text-left">
                <a href="/#/single-meditation" title="Meditate" [ngClass]="{'active': routerUrl == '/single-meditation'}">Meditate</a>
              </div>
            </li>
            <li class="nav-item row" [ngClass]="{'active': routerUrl == '/explore-paths'}">
              <div class="col-md-2 col-sm-2 col-xs-2 text-center">
                <i class="icon icon-wb stroke N7"></i>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5 text-left">
                <a href="/#/explore-paths" title="Explore Paths " [ngClass]="{'active': routerUrl == '/explore-paths'}">Explore Paths </a>
              </div>
            </li>
            <li class="nav-item row" [ngClass]="{'active': routerUrl == '/my-paths'}">
              <div class="col-md-2 col-sm-2 col-xs-2 text-center">
                <i class="icon icon-wb stroke L20"></i>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5 text-left">
                <a href="/#/my-paths" title="My Paths" [ngClass]="{'active': routerUrl == '/my-paths'}">My Paths</a>
              </div>
            </li>
            <li class="nav-item row" [ngClass]="{'active': routerUrl == 'settings'}">
              <div class="col-md-2 col-sm-2 col-xs-2 text-center">
                <i class="icon icon-wb stroke P1"></i>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5 text-left">
                <a href="/#/settings/profile" title="Profile Settings" [ngClass]="{'active': routerUrl == 'settings'}">Profile Settings</a>
              </div>
            </li>
            <li class="nav-item row">
              <div class="col-md-2 col-sm-2 col-xs-2 text-center">
                <i class="icon icon-wb stroke S14"></i>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5 text-left">
                <a title="Log Out" (click)=logOut()>Log Out</a>
              </div>
            </li>
          </ul>
        </perfect-scrollbar>
        <ul class="nav col-md-12 mobile-show">
          <li class="nav-item row" [ngClass]="{'active': routerUrl == '/home'}">
            <div class="col-md-2 col-sm-2 col-xs-2 text-center">
              <i class="icon icon-wb stroke O8"></i>
            </div>
            <div class="col-md-5 col-sm-5 col-xs-5 text-left">
              <a href="/#/home" title="Dashboard" [ngClass]="{'active': routerUrl == '/home'}">Dashboard</a>
            </div>
          </li>
          <li class="nav-item row" [ngClass]="{'active': routerUrl == '/single-meditation'}">
            <div class="col-md-2 col-sm-2 col-xs-2 text-center">
              <i class="icon icon-wb stroke F19"></i>
            </div>
            <div class="col-md-5 col-sm-5 col-xs-5 text-left">
              <a href="/#/single-meditation" title="Meditate" [ngClass]="{'active': routerUrl == '/single-meditation'}">Meditate</a>
            </div>
          </li>
          <li class="nav-item row" [ngClass]="{'active': routerUrl == '/explore-paths'}">
            <div class="col-md-2 col-sm-2 col-xs-2 text-center">
              <i class="icon icon-wb stroke N7"></i>
            </div>
            <div class="col-md-5 col-sm-5 col-xs-5 text-left">
              <a href="/#/explore-paths" title="Explore Paths " [ngClass]="{'active': routerUrl == '/explore-paths'}">Explore Paths </a>
            </div>
          </li>
          <li class="nav-item row" [ngClass]="{'active': routerUrl == '/my-paths'}">
            <div class="col-md-2 col-sm-2 col-xs-2 text-center">
              <i class="icon icon-wb stroke L20"></i>
            </div>
            <div class="col-md-5 col-sm-5 col-xs-5 text-left">
              <a href="/#/my-paths" title="My Paths" [ngClass]="{'active': routerUrl == '/#/my-paths'}">My Paths</a>
            </div>
          </li>
          <li class="nav-item row" [ngClass]="{'active': routerUrl == 'settings'}">
            <div class="col-md-2 col-sm-2 col-xs-2 text-center">
              <i class="icon icon-wb stroke P1"></i>
            </div>
            <div class="col-md-5 col-sm-5 col-xs-5 text-left">
              <a href="/#/settings/profile" title="Profile Settings" [ngClass]="{'active': routerUrl == 'settings'}">Profile Settings</a>
            </div>
          </li>
          <li class="nav-item row">
            <div class="col-md-2 col-sm-2 col-xs-2 text-center">
              <i class="icon icon-wb stroke S14"></i>
            </div>
            <div class="col-md-5 col-sm-5 col-xs-5 text-left">
              <a title="Log Out" (click)=logOut()>Log Out</a>
            </div>
          </li>
        </ul>
      </nav>
      <section id="sidenav-exercise" class="b-row">
        <div class="b-col-md-12" *ngIf="activeExerciseObj.id">
          <h1 class="heading heading-section">Your next exercise</h1>
          <article class="exercise">
            <a href="/#/exercise/{{activeExerciseObj.id}}">
              <h1 class="heading heading-md heading-underline">{{activeExerciseObj.name}}</h1>
            </a>
            <p class="text text-md">{{ (activeExerciseObj.description.length>100) ? (activeExerciseObj.description | slice:0:100 )+'...' : (activeExerciseObj.description)}}
              <a href="/#/exercise/{{activeExerciseObj.id}}" data-action="expandText">more</a>
            </p>
            <a role="button" href="/#/exercise/current/ongoing" class="btn btn-block btn-lg btn-primary">Do this Exercise</a>
          </article>
        </div>
      </section>
    </div>
  </aside>
</div>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/menu/menu.component.html